/**
 * Converts a category English name to a filesystem-safe directory slug.
 * 
 * All category folders are formatted as kebab-case (e.g., "Sushi" -> "sushi", "Chinese Cuisine" -> "chinese-cuisine").
 * 
 * This mapping ensures image paths resolve correctly.
 */
export function getCategoryImageDir(enName: string): string {
  return enName.toLowerCase().replace(/\s+/g, '-')
}
